import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import api from '@/api';
import { toast } from '@/lib/toast';
import { computed, reactive, ref } from 'vue';
import ProcedurePage from "@/components/ProcedurePage.vue";
import ContactPerson from '@/components/procedure/ContactPerson.vue';
import WinnersInfo from '@/components/procedure/WinnersInfo.vue';
import Config from '@/config';

interface Procedure {
  id?: number
  type?: string
  goodName?: string
  registryNumber?: string
  status: {
    name: string
    code: string
  }
  startMaxPrice?: string
  orgFullName?: string,
  contactPerson: {
    userFullName: string,
    userPhone: string,
    userEmail: string
  },
  withPositions: boolean,
  isWithoutStartMaxPrice?: boolean,
  isNds?: boolean,
  isClosed: boolean,
}

interface Access {
  canViewCompletedProcedure: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcedureCompleted',
  setup(__props) {

const loading = ref<Boolean>();

const procedure = reactive<Procedure>({
  id: null,
  type: '',
  goodName: '',
  registryNumber: '',
  status: { name: '', code: '' },
  startMaxPrice: '',
  orgFullName: '',
  contactPerson: {
    userFullName: '',
    userPhone: '',
    userEmail: '',
  },
  withPositions: false,
  isWithoutStartMaxPrice: false,
  isNds: false,
  isClosed: false,
});

const access = reactive<Access>({
  canViewCompletedProcedure: false,
});

const procedureActions = reactive({
  primaryAction: [],
  secondaryActions: [],
});

const types = ref<{
  title: string
  value: string
}[]>([]);

const winners = reactive([]);

const result = reactive({
  isWinner: false,
  isCurrentContragentWinner: false,
});

const isHiddenContractPerson = Config.getConfig('HIDDEN_CONTACT_PERSON');

const actionsInfo = computed<object>(
  () => ({
    p: {
      id: procedure.id,
      registryNumber: procedure.registryNumber
    },
    access,
    procedureActions,
  })
);

const load = async (procedureId) => {
  loading.value = true;

  try {
    const resp = await api.get(`/procedures/${procedureId}/completed`);

    Object.assign(procedure, resp.procedure);
    Object.assign(procedureActions, resp.procedureActions);
    Object.assign(access, resp.access);
    Object.assign(winners, resp.winners);
    Object.assign(result, resp.result);

    types.value = resp.types.map((elem) => ({
      title: elem.name,
      value: elem.code,
    }));

  } catch (e) {
    toast.error(e.message);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProcedurePage, {
    id: _ctx.$route.params.id,
    procedure: procedure,
    result: result,
    "actions-info": actionsInfo.value,
    "load-func": load,
    status: procedure.status,
    types: types.value,
    isClosed: procedure.isClosed,
    "show-cancel-details": true,
    "onUpdate:procedureGoodName": _cache[0] || (_cache[0] = ($event: any) => (procedure.goodName = $event)),
    "onUpdate:procedureType": _cache[1] || (_cache[1] = ($event: any) => (procedure.type = $event))
  }, {
    default: _withCtx(() => [
      (!_unref(isHiddenContractPerson))
        ? (_openBlock(), _createBlock(ContactPerson, {
            key: 0,
            organization: procedure.orgFullName,
            contact: procedure.contactPerson,
            view: true
          }, null, 8 /* PROPS */, ["organization", "contact"]))
        : _createCommentVNode("v-if", true),
      _createVNode(WinnersInfo, {
        winners: winners,
        withPositions: procedure.withPositions,
        "procedure-step-code": procedure.status.code,
        procedure: procedure
      }, null, 8 /* PROPS */, ["winners", "withPositions", "procedure-step-code", "procedure"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "procedure", "result", "actions-info", "status", "types", "isClosed"]))
}
}

})